import { OktaAuth } from '@okta/okta-auth-js';
import { VITE_OKTA_CID, VITE_OKTA_ISSUER } from '../envs';

export const oktaAuth = new OktaAuth({
  issuer: `https://auth.options.ai/oauth2/${VITE_OKTA_ISSUER}`,
  clientId: VITE_OKTA_CID,
  redirectUri: window.location.origin + '/auth/callback',
  scopes: ['openid', 'email', 'offline_access'],
  pkce: true,
  tokenManager: {
    autoRenew: true,
    secure: true,
    storage: localStorage,
  },
  maxClockSkew: 60 * 60 * 12,
});
